import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { SxProps } from '@mui/material/styles';
import * as React from 'react';

import styles from './Dialog.module.scss';

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

export interface DialogProps {
    title?: string;
    isOpen: boolean;
    className?: string;
    children?: React.ReactNode;
    onClose: () => void;
    setPadding?: boolean;
    encloseCloseButton?: boolean;
    sx?: SxProps;
    transitionDuration?: number | { appear?: number; enter?: number; exit?: number };
}

const Drawer: React.FC<DialogProps> = ({
    title,
    isOpen,
    children,
    onClose,
    className,
    setPadding = true,
    encloseCloseButton: circleCloseButton = false,
    sx,
    transitionDuration = { enter: 225, exit: 195 },
}) => {
    return (
        <Dialog
            onClose={onClose}
            className={`${className} legos-layout ${styles['dialog']}`}
            aria-labelledby={title ? title : 'customized-dialog-title'}
            BackdropProps={{ style: { backgroundColor: 'rgba(5, 51, 97, 0.56)' } }}
            open={isOpen}
            sx={sx}
            transitionDuration={transitionDuration}>
            {onClose && (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    className={
                        circleCloseButton ? styles['circle-close-button'] : styles['close-button']
                    }>
                    <CloseIcon />
                </IconButton>
            )}
            <DialogContent>
                <div style={{ padding: `${setPadding ? '24px' : '0'}` }}>{children}</div>
            </DialogContent>
        </Dialog>
    );
};

export default Drawer;
